<script>
import HsSectionCell from "@/base/hs-tableview/hs-section/hs-section-cell.vue";

export default {
  components: {HsSectionCell},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      content: ''
    }
  },
  computed: {
    currentShow: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.content = ''
      }
    }
  },
}
</script>

<template>
  <van-dialog
      v-model="currentShow"
      :title="title"
      :confirm-button-text="$t('Confirm')"
      show-cancel-button
      :cancel-button-text="$t('Cancel')"
      @confirm="$emit('confirm', content)"
      z-index="9"
      :close-on-click-overlay="true"
      width="280px"
  >
    <div class="c-examine-dialog">
      <div class="input-box">
        <hs-section-cell
            class="hs-section-cell"
            v-model="content"
            :placeholder="placeholder"
            type="input"
            :showLogo="false"
            clearable
            @clear="content = ''"
        />
      </div>
    </div>
  </van-dialog>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.c-examine-dialog{
  width: 100%;
  .input-box{
    border-radius: 8px;
    background-color: $color_black_20;
    overflow: hidden;
    >.hs-section-cell{
      padding: 0 4px 0 8px;
      min-height: 40px;
      >>> input{
        background-color: $color_black_20;
        padding: 0;
      }
    }
  }
}
</style>

